// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { PERSONAL_DATA_URL, PERSONAL_DATA_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { CompanyIndex } = lazily(() => import('pages/back-office/personal-data/company'))

const companyRoutes: IRoute[] = [
  {
    path: PERSONAL_DATA_URL.COMPANY,
    component: CompanyIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: PERSONAL_DATA_MODULE,
      requireAuth: true,
      attrs: {
        label: 'backOffice.companyData',
        accessCodes: [224],
      },
    },
  },
]

export { companyRoutes }
